export class DataValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = "ValidationError";
  }
}
